import {
    Avatar,
    ColManager,
    getCalendarFormat,
    TDataTableColumnsData,
    TDataTableRowData,
    TDObject
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { t } from "i18next"
import { NameTableCol } from "../../components/tables/nameTableCol"
import { ContactActions } from "./components/contactActions"
import { TGetListingRowsContact } from "./types"

export function getListingColsData(customAttributes?: TDObject): () => TDataTableColumnsData[] {
    const cols: TDataTableColumnsData[] = [
        {
            id: "email",
            label: t("general-email"),
            sortable: true
        },
        {
            id: "subscribed_on",
            label: t("general-subscribed_on"),
            sortable: true
        },
        {
            id: "status",
            label: t("general-status"),
            sortable: true
        },
        {
            id: "bounces_count",
            label: t("general-bounce-count"),
            sortable: true
        },
        {
            id: "last_bounce_type",
            label: t("general-bounce-type"),
            sortable: true
        },
        {
            id: "tags",
            label: t("general-tag_other")
        },
        {
            id: "interests",
            label: t("general-interest_other")
        }
    ]

    if (customAttributes) {
        cols.push(...Object.entries(customAttributes).map(([key, value]) => ({
            id: key,
            label: value
        })))
    }

    cols.push({
        id: "actions",
        label: <Stack direction="row" justifyContent="flex-end">
            <ColManager
                removedColumns={[]}
                columns={cols.slice(0, -1)}
                onVisibilityChange={() => { }} //TODO: Implement onVisibilityChange
            />
        </Stack>
    })

    return () => cols
}

export function getListingRows({
    contact,
    handleOpen,
    handleUnsubscribe,
    handleAddToSuppressionList,
    handleDelete
}: TGetListingRowsContact): TDataTableRowData {
    const data: TDataTableRowData = {
        id: contact.id,
        email: {
            id: contact.email,
            content: <NameTableCol name={contact.email} avatar={<Avatar email={contact.email} firstName={contact.email[0]} />
            } />
        },
        subscribed_on: getCalendarFormat({ unixDate: contact.subscribed_on }),
        status: t("general-status-" + contact.status),
        bounces_count: contact.bounces_count,
        last_bounce_type: contact.last_bounce_type,
        tags: contact.tags,
        interests: contact.interests,
        actions: {
            id: "actions",
            content: <ContactActions
                contact={contact}
                onOpen={handleOpen}
                onUnsubscribe={handleUnsubscribe}
                onAddToSuppressionList={handleAddToSuppressionList}
                onDelete={handleDelete}
            />
        }
    }

    contact.custom_attributes?.forEach((attribute) => {
        data[attribute.name] = attribute.value
    })

    return data
}